import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useTranslation } from "react-i18next";

function HistoryArticle({ article }) {
  const { t } = useTranslation();
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    setError(false);

    fetch(article.content)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Impossibile caricare l'articolo");
        }

        return response.text();
      })
      .then((text) => {
        if (!cancelled) {
          setContent(text);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [article.content]);

  if (loading) {
    return <div className="article-text"></div>;
  }

  if (error) {
    return <div className="article-text">{t("article.loadingError")}</div>;
  }

  return (
    <article>
      <img
        src={article.cover}
        alt=""
        className="mb-8 aspect-video w-full rounded-lg object-cover"
      />

      <header className="mb-8">
        <p className="mb-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
          {article.category}
        </p>

        <h1 className="article-detail-title">{article.title}</h1>

        <p className="article-detail-author">Di {article.author}</p>

        {article.description && (
          <p className="article-detail-description">{article.description}</p>
        )}
      </header>

      <div className="history-markdown">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            h1: ({ children }) => (
              <h1 className="article-detail-h1">{children}</h1>
            ),

            h2: ({ children }) => (
              <h2 className="article-detail-h2">{children}</h2>
            ),

            h3: ({ children }) => (
              <h3 className="article-detail-h3">{children}</h3>
            ),

            p: ({ children }) => <p className="article-detail-p">{children}</p>,

            ul: ({ children }) => (
              <ul className="mb-5 list-disc space-y-2 pl-6 text-gray-700">
                {children}
              </ul>
            ),

            ol: ({ children }) => (
              <ol className="mb-5 list-decimal space-y-2 pl-6 text-gray-700">
                {children}
              </ol>
            ),

            blockquote: ({ children }) => (
              <blockquote className="my-6 border-l-4 border-gray-300 pl-5 italic text-gray-600">
                {children}
              </blockquote>
            ),

            a: ({ href, children }) => (
              <a
                href={href}
                className="font-medium underline underline-offset-2 hover:no-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                {children}
              </a>
            ),

            img: ({ src, alt }) => (
              <figure className="my-8">
                <img
                  src={src}
                  alt={alt || ""}
                  className="mx-auto max-h-[600px] rounded-lg object-contain"
                />

                {alt && (
                  <figcaption className="mt-2 text-center text-sm text-gray-500">
                    {alt}
                  </figcaption>
                )}
              </figure>
            ),

            // table: ({ children }) => (
            //   <div className="my-6 overflow-x-auto">
            //     <table className="w-full border-collapse border border-gray-300 text-sm">
            //       {children}
            //     </table>
            //   </div>
            // ),

            // th: ({ children }) => (
            //   <th className="border border-gray-300 bg-gray-100 px-4 py-2 text-left font-semibold">
            //     {children}
            //   </th>
            // ),

            // td: ({ children }) => (
            //   <td className="border border-gray-300 px-4 py-2">{children}</td>
            // ),

            hr: () => <hr className="my-10 border-gray-200" />,
          }}
        >
          {content}
        </ReactMarkdown>
      </div>
    </article>
  );
}

export default HistoryArticle;
